import { Card } from "react-bootstrap";
import "./Validations.scss";

export default function Validations({ steps, currentStep }) {
  return (
    <div className="validations-container">
      <h6 className="mb-3">Validations</h6>

      <div className="d-flex gap-3">
        {steps.map((step, index) => (
          <Card
            key={index}
            className={`validation-card ${
              currentStep === index + 1 ? "active" : ""
            }`}>
            <Card.Body>
              <h6 className="title">Validation {index + 1}</h6>
              <p className="mb-1">{step.name}</p>
              <p className="mb-1">
                <strong>Date :</strong>{" "}
                {step.date ? (
                  step.date.toLocaleDateString()
                ) : (
                  <span className="text-muted">-</span>
                )}
              </p>
              <p className="mb-0">
                <strong>Signature :</strong>{" "}
                {step.signed ? "✔️" : <span className="text-muted">-</span>}
              </p>
            </Card.Body>
          </Card>
        ))}
      </div>

      {/* Circuit */}
      <div className="circuit mt-3 text-muted">
        Circuit de validation en cours : {steps.map((s) => s.name).join(" > ")}
      </div>
    </div>
  );
}
